export default 'https://tme.understood.org/assets/bundle_1.cfd2bd3a.vtt'